import { useTranslation } from 'next-i18next';

export function useCustomTranslations() {
  const { i18n } = useTranslation();

  /**
   * Custom translate a string
   * This function name is inspired by the next t('') function
   *
   *
   * @param defaultValue : The default value to use when no translation is available
   * @param object : The object containing an array of translations
   * @returns string : The translated object
   */
  function ct(defaultValue?: string | null, object?: any, translationsKey = 'translations'): string | null {
    if (!object || !object[translationsKey] || object[translationsKey].length === 0) return defaultValue || null;
    const translation = object[translationsKey].find((t: any) => t.language === i18n.language);
    if (!translation) return defaultValue || null;
    return translation.value;
  }

  return {
    ct,
  };
}
